<template>
    <div class="run-point">
        <div class="breadcrumb">跑步点位管理
            <el-button class="right_f" type="primary" @click="newRunPointManage">新增</el-button>
        </div>

        <!-- 状态下拉框 -->
        <div class="point-status">
            <el-select v-model="state" @change="getRunPoints">
                <el-option label="全部" value='0'></el-option>
                <el-option label="草稿" value='1'></el-option>
                <el-option label="待上线" value='2'></el-option>
                <el-option label="已上线" value='3'></el-option>
                <el-option label="过期" value='4'></el-option>
            </el-select>
        </div>

        <div class="com-list">
            <!-- 跑步点位列表 -->
            <el-table :data="runPoints" style="overflow-x: auto;">
                <el-table-column prop="index" label="序号" align='center' width="80">
                </el-table-column>
                <el-table-column prop="description" label="广告说明" align='center'>
                </el-table-column>
                <el-table-column prop="applicableCampus" label="适用学校" align='center' width="120">
                </el-table-column>
                <el-table-column prop="showtime" label="展示时间" align='center'>
                </el-table-column>
                <el-table-column prop="state" label="状态" align='center' width="80">
                </el-table-column>
                <el-table-column prop="latestdo" label="最近操作记录" align='center' width="200">
                </el-table-column>
                <el-table-column inline-template label="操作">
                    <span>
                        <el-button class="option" v-if="row.state == '草稿'" type="text" @click="editRunPointManage(row.id)">编辑</el-button>
                        <el-button class="option" type="text" @click="deleteRunPointManage(row)">删除</el-button>
                    </span>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination">
            <el-pagination v-show="totalCount > 0" layout="prev, pager, next, jumper" :page-size="pageSize" :current-page="pageNum" :total="totalCount"
                @current-change="handleCurrentChange">
            </el-pagination>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                state: '0',
                totalCount: 0,
                pageNum: 1,
                pageSize: 20,
                runPoints: [],
                operatorId: ''
            }
        },
        computed: {
            user() {
                return this.$store.state.user
            }
        },
        mounted() {
            this.operatorId = JSON.parse(localStorage.getItem('user')).userId;

            this.getRunPoints();
        },
        methods: {
            //获取跑步管理列表
            getRunPoints() {
                this.runPoints = [];

                this.$http({
                    method: 'POST',
                    url: this.$util.domain + '/adminapi/v27/runningpointad/list',
                    body: JSON.stringify({
                        pageNum: this.pageNum,
                        pageSize: this.pageSize,
                        state: this.state * 1
                    })
                }).then((response) => {
                    if (response.data.error === 10000) {
                        //请求成功进行数据解析和赋值
                        let dataList = response.data.data.list;
                        this.totalCount = response.data.data.total;

                        if (dataList && dataList.length > 0) {
                            for (let i = 0; i < dataList.length; i++) {
                                let index = i + 1,
                                    description = dataList[i].description,
                                    applicableCampus = dataList[i].applicableCampus == 0 ? '全部' : '部分',
                                    startTime = new Date(dataList[i].startTime).format('yyyy/MM/dd hh:00'),
                                    endTime = new Date(dataList[i].endTime).format('yyyy/MM/dd hh:00'),
                                    lastOperateTime = new Date(dataList[i].lastOperateTime).format('yyyy/MM/dd hh:mm'),
                                    lastOperator = dataList[i].lastOperator || '',
                                    id = dataList[i].id,
                                    state = dataList[i].status,
                                    operatorId = dataList[i].lastOperatorId;

                                switch (state) {
                                    case 1:
                                        state = '草稿'
                                        break;
                                    case 2:
                                        state = '待上线'
                                        break;
                                    case 3:
                                        state = '已上线'
                                        break;
                                    default:
                                        state = '过期'
                                        break;
                                }

                                this.runPoints.push({
                                    index,
                                    description,
                                    applicableCampus,
                                    state,
                                    id,
                                    operatorId,
                                    showtime: startTime + ' - ' + endTime,
                                    latestdo: lastOperator + '  ' + lastOperateTime
                                })
                            }
                        }
                    }
                });
            },
            newRunPointManage() {
                location.href = "#/yunying/runPoint/newRunPoint";
            },
            editRunPointManage(id) {
                location.href = "#/yunying/runPoint/newRunPoint?runPointId=" + id;
            },
            handleCurrentChange(val) {
                this.pageNum = val;
                this.getRunPoints();
            },
            //删除跑步点位
            deleteRunPointManage(row) {
                //弹出是否删除跑步点位确认框
                this.$confirm('你确定要删除此条广告吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {

                    // 若选择是，发送删除请求
                    this.$http({
                        method: 'POST',
                        url: this.$util.domain + '/adminapi/v27/runningadpoint/del',
                        body: JSON.stringify({
                            id: row.id * 1,
                            operatorId: this.operatorId * 1
                        })
                    }).then(response => {
                        if (response.data.error === 10000) {
                            //删除成功，重新请求列表
                            this.getRunPoints();
                        }else{
                            this.$util.errorMsg('删除失败');
                        }
                    }).catch(response => {
                        // 删除失败
                        this.$util.errorMsg('删除失败');
                    })
                })
            }
        }
    }
</script>
<style>
    .run-point .el-select {
        display: inline-block;
    }

    .run-point img {
        display: block;
        width: 70%;
        height: 80%;
        margin: 10px;
    }

    .run-point span .el-button {
        width: 70px;
        padding: 5px;
        border: solid 1px #999;
    }

    .run-point .el-input {
        display: inline-block;
    }

    .run-point .el-button {
        display: inline-block;
    }

    .run-point .el-button+.el-button {
        margin-left: 0;
    }

    .point-status {
        margin-left: 30px;
        margin-bottom: 20px;
    }
</style>


// WEBPACK FOOTER //
// runPointManage.vue?3fc4b2d6